import getConfig from "next/config";
const { NODE_ENV, APP_THEME, APP_VERSION } = getConfig().publicRuntimeConfig;

export const RedirectToHome = e => {
	const url =
		document.location.protocol +
		"//" +
		document.location.host +
		document.location.pathname +
		"?legacy=1";

	if (APP_THEME != "aocubo") {
		if (NODE_ENV === "production") {
			document.location.href = url;
		} else {
			console.error("If this were in production, you would have been redirected to: " + url);
			console.log(e);
		}
	}
};


export const HandleGoogleBotErrors = async (event, userAgent='') => {
	let slackErrData = {
		app_version: APP_VERSION,
		url: event?.request?.url,
		UserAgent: event?.request?.headers["headers"],
		exception: event?.exception?.values[0]?.value,
		query: event?.extra?.query,
		queryErrMsg: event?.extra?.error?.message,
		queryParams: event?.extra?.variable?.params,
		'=================================':'====================================================',
		breadcrumbs: JSON.stringify(event?.breadcrumbs),
	}

	await fetch('https://hooks.slack.com/services/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', {
		body: JSON.stringify({'text': JSON.stringify(slackErrData, null, 4), 'username':'Error in userAgent BOT'},null,4),
		method: 'POST'
	})
}